import React from 'react';
import { CampaignShimmeredDetailsList } from '@bingads-webui-grid/campaign-details-list';

interface RecommendationDetailsGridProps {
  columns: Array<any>;
  items: Array<any>;
  pageNumber: number;
  pageSize: number;
  total: number;
  onPageChange: () => void;
  onPageSizeChange: () => void;
  onSort: () => void;
  sortedColumn: Array<any>;
}

export const RecommendationDetailsGrid: React.FC<RecommendationDetailsGridProps> = ({
  columns,
  items,
  pageNumber,
  pageSize,
  onPageChange,
  onPageSizeChange,
  onSort,
  sortedColumn,
  total,
}) => (
  // eslint-disable-next-line react/jsx-filename-extension
  <CampaignShimmeredDetailsList
    items={items}
    columns={columns}
    enableShimmer={!items}
    onSort={onSort}
    sortedColumn={sortedColumn}
    pager={{
        pageNumber,
        pageSize,
        total,
        onPageChange,
        onPageSizeChange,
      }}
  />
);

